import React from 'react';
import PropTypes from 'prop-types';
import history from 'routing/history';
import { useDispatch, useSelector } from 'react-redux';
import { logOutUser } from 'state/app';
import Button from 'products/nomad_insurance/components/Button';
import { ReactComponent as HomeIcon } from 'products/nomad_insurance/assets/img/icons/menu/home.svg';
import {
  MenuContainer,
  Link,
  ItemContainer,
  Header,
  SpaceBetweenContainer,
  ButtonContainer
} from './styled';
import FaqSearchBar from './components/FaqSearchBar';
import MoreInfoSection from './components/MoreInfoSection';
import ProfileInfoSection from './components/ProfileInfoSection';

const Menu = React.forwardRef(({ isOpen, onClose }, ref) => {
  const { user, isInitInProgress } = useSelector((state) => state.app);
  const { planholder } = useSelector((state) => state.nomadInsurance.planholder);
  const { isAuthenticated } = user;
  const dispatch = useDispatch();

  const navigate = (url) => {
    onClose();
    history.push(url);
  };

  const handleLogout = () => {
    dispatch(logOutUser());
  };

  if (planholder && !planholder?.hasCompletedProfile) {
    return (
      <MenuContainer ref={ref} isOpen={isOpen}>
        <SpaceBetweenContainer>
          <div>
            <ItemContainer>
              <Link onClick={onClose} to="/nomad-insurance">
                <HomeIcon /> Home
              </Link>
              <MoreInfoSection onClose={onClose} />
            </ItemContainer>
            <FaqSearchBar onSearch={onClose} product="nomad-insurance" />
          </div>
          <ButtonContainer>
            <Button
              color="confetti"
              onClick={() => navigate('nomad-insurance/registration')}
            >
              Complete profile
            </Button>
            <Button variant="outline" color="pickledBluewood" onClick={handleLogout}>
              Logout
            </Button>
          </ButtonContainer>
        </SpaceBetweenContainer>
      </MenuContainer>
    );
  }

  if (!isInitInProgress) {
    return isAuthenticated ? (
      <MenuContainer ref={ref} isOpen={isOpen}>
        <SpaceBetweenContainer>
          <div>
            <Header>My dashboard</Header>
            <ItemContainer>
              <ProfileInfoSection onClose={onClose} />
            </ItemContainer>
            <Header>More info</Header>
            <ItemContainer>
              <MoreInfoSection onClose={onClose} />
            </ItemContainer>
            <FaqSearchBar onSearch={onClose} product="nomad-insurance" />
          </div>

          <Button variant="outline" color="pickledBluewood" onClick={handleLogout}>
            Logout
          </Button>
        </SpaceBetweenContainer>
      </MenuContainer>
    ) : (
      <MenuContainer ref={ref} isOpen={isOpen}>
        <SpaceBetweenContainer>
          <div>
            <ItemContainer>
              <Link onClick={onClose} to="/nomad-insurance">
                <HomeIcon /> Home
              </Link>
              <MoreInfoSection onClose={onClose} />
            </ItemContainer>
            <FaqSearchBar onSearch={onClose} product="nomad-insurance" />
          </div>
          <ButtonContainer>
            <Button color="confetti" onClick={() => navigate('/nomad-insurance/signup')}>
              Sign up
            </Button>
            <Button
              variant="outline"
              color="pickledBluewood"
              onClick={() => navigate('/login')}
            >
              Login
            </Button>
          </ButtonContainer>
        </SpaceBetweenContainer>
      </MenuContainer>
    );
  }

  return null;
});

Menu.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default Menu;
